import React from "react";
import { MapPin, Navigation } from "lucide-react";

const DeliveryMapPanel = ({
  mapContainerRef,
  isMapMoving,
  resolvingLocation,
  handleUseCurrentLocation,
  selectedMapAddress,
}) => {
  return (
    <div className="relative order-first flex h-[420px] overflow-hidden bg-gradient-to-br from-[#eaf7ff] via-[#b9e5ff] to-[#188bdd] p-4 sm:h-[460px] md:h-[500px] lg:order-none lg:h-full lg:p-5">
      <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full bg-white/30 blur-3xl" />
      <div className="absolute -bottom-24 -left-20 h-80 w-80 rounded-full bg-blue-300/40 blur-3xl" />

      <div className="relative z-10 flex h-full w-full flex-col gap-4">
        <div className="relative flex-1 overflow-hidden rounded-3xl border border-white/60 bg-white shadow-2xl">
          <div ref={mapContainerRef} className="h-full w-full" />

          {/* CENTER FIXED PIN */}
          <div className="pointer-events-none absolute left-1/2 top-1/2 z-30 flex -translate-x-1/2 -translate-y-full flex-col items-center">
            <div
              className={`flex flex-col items-center transition-all duration-300 ease-out ${
                isMapMoving || resolvingLocation
                  ? "-translate-y-3 scale-105"
                  : "translate-y-0 scale-100"
              }`}
            >
              <div
                className={`flex h-5 w-5 items-center justify-center rounded-full border-2 border-white bg-blue-600 transition-all duration-300 ${
                  isMapMoving || resolvingLocation ? "shadow-xl" : "shadow-md"
                }`}
              >
                <div className="h-2 w-2 rounded-full bg-white" />
              </div>

              <div className="h-3 w-[2px] bg-blue-600" />
            </div>

            <div
              className={`h-1.5 w-5 rounded-full bg-black/20 blur-[1px] transition-all duration-300 ease-out ${
                isMapMoving || resolvingLocation
                  ? "translate-y-1 scale-75 opacity-30"
                  : "translate-y-0 scale-100 opacity-50"
              }`}
            />
          </div>

          {/* BOTTOM CONTROLS */}
          <div className="absolute bottom-4 left-4 right-4 hidden items-center justify-between gap-3 md:flex">
            <button
              type="button"
              onClick={handleUseCurrentLocation}
              className="inline-flex items-center gap-2 rounded-2xl bg-blue-600 px-4 py-2 text-[12px] font-bold text-white shadow-lg transition hover:bg-blue-700"
            >
              <Navigation size={15} />
              Current Location
            </button>

            <div className="rounded-2xl bg-white/95 px-3 py-2 text-[11px] font-bold text-slate-600 shadow-lg backdrop-blur">
              {resolvingLocation
                ? "Finding exact address..."
                : isMapMoving
                  ? "Release map to select"
                  : "Move map to choose"}
            </div>
          </div>

          {/* SELECTED ADDRESS CARD */}
          <div className="absolute bottom-4 left-4 right-4 z-40 rounded-2xl bg-white/95 px-3 py-2 shadow-lg backdrop-blur md:bottom-16">
            <div className="flex items-center gap-2">
              <MapPin size={15} className="shrink-0 text-blue-600" />

              <p className="min-w-0 flex-1 truncate text-[12px] font-semibold text-slate-700">
                {resolvingLocation
                  ? "Finding exact address..."
                  : selectedMapAddress || "Move map to choose address"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryMapPanel;